import React, { PureComponent } from 'react';
import { Modal, Button, Row, Col } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import domtoimage from 'dom-to-image';

import {
  OrderStatusInitIcon,
  OrderStatusInProgressIcon,
  OrderStatusFailedIcon,
  OrderStatusExpiredIcon,
  OrderStatusRefundedIcon,
  OrderStatusIcon,
  OrderStatusCompletedIcon,
  DanaLogoBlueIcon,
} from 'modules/AllBillers/components/Icons';
import './Transactions.style.less';
import { formatMoney } from '../../../../shared/utils/StringUtil';

import { ORDER_STATUS } from '../../constant/AllBillerDefaultVar';

import text from './Transactions.page.translation';

class TransactionDetailModal extends PureComponent {
  constructor(props) {
    super(props);
    this.invoiceRef = React.createRef();
  }

  onClickDownload = invoiceId => () => {
    const node = this.invoiceRef.current;

    domtoimage.toJpeg(node, { bgcolor: '#ffffff' }).then(dataUrl => {
      const link = document.createElement('a');
      link.download = `invoice-${invoiceId}.jpeg`;
      link.href = dataUrl;
      link.click();
    });
  };

  renderModalHeader = invoiceId => (
    <div>
      <div className="modal-header-container">Invoice {invoiceId}</div>
      <div className="modal-separator" />
    </div>
  );

  renderModalFooter = (invoiceId, handleCancel) => (
    <div>
      <div className="footer-btn-container">
        <Button className="footer-btn-cancel" onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          className="footer-btn-download"
          type="primary"
          onClick={this.onClickDownload(invoiceId)}
        >
          Download
        </Button>
      </div>
    </div>
  );

  renderInvoiceHeader = invoice => {
    const serviceName = _.get(invoice, 'biller.service.name');
    const serviceNameDisplay = serviceName.toUpperCase();
    const finishTime = _.get(invoice, 'dana_finish_time');
    const finishTimeDisplay = moment(finishTime).format('DD MMM YYYY HH:mm');

    return (
      <div>
        <div className="dana-logo-container">
          <DanaLogoBlueIcon />
        </div>
        <Row type="flex" align="middle">
          <Col span={12}>{finishTimeDisplay}</Col>
          <Col span={12} className="service-name">
            <div className="service-name-container">{serviceNameDisplay}</div>
          </Col>
        </Row>
        <div className="detail-separator-dash" />
      </div>
    );
  };

  renderLineActive = () => <div className="line active" />;

  renderLineDeactive = () => <div className="line deactive" />;

  renderStepInProgress = () => {
    const { formatMessage } = this.props;
    const lineActive = this.renderLineActive();
    const lineDeactive = this.renderLineDeactive();

    return (
      <Row type="flex" justify="center" align="top" className="step-row">
        <Col span={5}>
          <OrderStatusInitIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.init)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineActive}
        </Col>
        <Col span={5}>
          <OrderStatusInProgressIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.inProgress)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineDeactive}
        </Col>
        <Col span={5}>
          <OrderStatusIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.status)}
          </div>
        </Col>
      </Row>
    );
  };

  renderStepCompleted = () => {
    const { formatMessage } = this.props;
    const lineActive = this.renderLineActive();

    return (
      <Row type="flex" justify="center" align="top" className="step-row">
        <Col span={5}>
          <OrderStatusInitIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.init)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineActive}
        </Col>
        <Col span={5}>
          <OrderStatusInProgressIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.inProgress)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineActive}
        </Col>
        <Col span={5}>
          <OrderStatusCompletedIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.completed)}
          </div>
        </Col>
      </Row>
    );
  };

  renderStepFailed = () => {
    const { formatMessage } = this.props;
    const lineActive = this.renderLineActive();

    return (
      <Row type="flex" justify="center" align="top" className="step-row">
        <Col span={5}>
          <OrderStatusInitIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.init)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineActive}
        </Col>
        <Col span={5}>
          <OrderStatusInProgressIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.inProgress)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineActive}
        </Col>
        <Col span={5}>
          <OrderStatusFailedIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.failed)}
          </div>
        </Col>
      </Row>
    );
  };

  renderStepRefunded = () => {
    const { formatMessage } = this.props;
    const lineActive = this.renderLineActive();

    return (
      <Row type="flex" justify="center" align="top" className="step-row">
        <Col span={5}>
          <OrderStatusInitIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.init)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineActive}
        </Col>
        <Col span={5}>
          <OrderStatusInProgressIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.inProgress)}
          </div>
        </Col>
        <Col span={4} className="line-col">
          {lineActive}
        </Col>
        <Col span={5}>
          <OrderStatusRefundedIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.refunded)}
          </div>
        </Col>
      </Row>
    );
  };

  renderStepExpired = () => {
    const { formatMessage } = this.props;
    const lineActive = this.renderLineActive();

    return (
      <Row type="flex" justify="center" align="top" className="step-row">
        <Col span={4}>
          <OrderStatusInitIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.init)}
          </div>
        </Col>
        <Col span={13} className="line-col">
          {lineActive}
        </Col>
        <Col span={4}>
          <OrderStatusExpiredIcon />
          <div className="step-text">
            {formatMessage(text.orderStatus.expired)}
          </div>
        </Col>
      </Row>
    );
  };

  formatPriceDisplay = price => formatMoney(price);

  renderInvoiceDetail = invoice => {
    const { formatMessage } = this.props;

    const totalAmount = _.get(invoice, 'total_amount');
    const totalAmountDisplay = this.formatPriceDisplay(totalAmount);
    const transactionAmount = _.get(invoice, 'transaction_amount');
    const transactionAmountDisplay = this.formatPriceDisplay(transactionAmount);
    const adminFee = _.get(invoice, 'admin_fee');
    const adminFeeDisplay = this.formatPriceDisplay(adminFee);
    const serviceName = _.get(invoice, 'biller.service.name');
    const billerName = _.get(invoice, 'biller.name');
    const accountNumber = _.get(invoice, 'beneficiary_account_number');
    const accountName = _.get(invoice, 'beneficiary_full_name');
    const invoiceNo = _.get(invoice, 'invoice_number');

    return (
      <div>
        <div className="total-container">
          <div>{formatMessage(text.invoice.label.totalPayment)}</div>
          <div className="detail-value">{totalAmountDisplay}</div>
        </div>
        <div className="detail-container">
          <div>{formatMessage(text.invoice.label.paymentAmount)}</div>
          <div className="detail-value">{transactionAmountDisplay}</div>
        </div>
        <div className="detail-container">
          <div>{formatMessage(text.invoice.label.adminFee)}</div>
          <div className="detail-value">{adminFeeDisplay}</div>
        </div>
        <div className="detail-separator" />
        <div className="detail-title-container">
          <div>{formatMessage(text.invoice.label.informationDetail)}</div>
        </div>
        <div className="detail-container">
          <div>{formatMessage(text.invoice.label.serviceName)}</div>
          <div className="detail-value">{serviceName}</div>
        </div>
        <div className="detail-container">
          <div>{formatMessage(text.invoice.label.bankProvider)}</div>
          <div className="detail-value">{billerName}</div>
        </div>
        <div className="detail-container">
          <div>{formatMessage(text.invoice.label.creditCardName)}</div>
          <div className="detail-value">{accountNumber}</div>
        </div>
        <div className="detail-container">
          <div className="row-wrap-label">
            {formatMessage(text.invoice.label.nameOnCreditCard)}
          </div>
          <div className="row-wrap-value">{accountName}</div>
        </div>
        <div className="detail-container">
          <div className="row-wrap-label">
            {formatMessage(text.invoice.label.invoiceNumber)}
          </div>
          <div className="row-wrap-value">{invoiceNo}</div>
        </div>
      </div>
    );
  };

  renderInvoiceSteps = orderStatus => {
    switch (orderStatus) {
      case ORDER_STATUS.INIT:
      case ORDER_STATUS.IN_PROGRESS:
      default:
        return this.renderStepInProgress();
      case ORDER_STATUS.COMPLETED:
        return this.renderStepCompleted();
      case ORDER_STATUS.FAILED:
        return this.renderStepFailed();
      case ORDER_STATUS.REFUNDED:
        return this.renderStepRefunded();
      case ORDER_STATUS.EXPIRED:
        return this.renderStepExpired();
    }
  };

  render() {
    const { data, handleCancel } = this.props;

    if (data.length === 0) {
      return null;
    }
    const invoice = data[0];
    const orderStatus = _.get(invoice, 'sales_order.order_status');
    const invoiceId = _.get(invoice, 'invoice_number');

    const modalHeader = this.renderModalHeader(invoiceId);
    const modalFooter = this.renderModalFooter(invoiceId, handleCancel);
    const invoiceHeader = this.renderInvoiceHeader(invoice);
    const invoiceSteps = this.renderInvoiceSteps(orderStatus);
    const invoiceDetails = this.renderInvoiceDetail(invoice);

    return (
      <Modal
        className="transaction-detail-modal"
        bodyStyle={{ padding: '0px' }}
        centered
        title=""
        closable={false}
        visible={this.props.visible}
        footer={null}
        width={400}
      >
        {modalHeader}
        <div ref={this.invoiceRef} className="invoice-container">
          <div className="invoice-page">
            {invoiceHeader}
            {invoiceSteps}
            {invoiceDetails}
          </div>
          <div className="watermark" />
        </div>
        {modalFooter}
      </Modal>
    );
  }
}

TransactionDetailModal.propTypes = {
  data: PropTypes.array,
  visible: PropTypes.bool,
  handleCancel: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default TransactionDetailModal;
